<template>
  <div>
    <h2>Utilisateurs</h2>
    <div class="display">
      <div class="header">
        <ul>
          <li class="name"><a href="#">Nom <i class="fas fa-chevron-down"></i></a></li>
          <li class="desc"><a href="#">est admin <i class="fas fa-chevron-down"></i></a></li>
        </ul>
      </div>
      <div class="liste">
        <ul>
          <li v-for="user in users" :key="user.id">
            <div>
              <p class="name">{{ user.nom }}</p>
              <p class="isadmin"><toggle-button @change="changeAdmin(user.nom)" :value="user.estAdmin"/></p>
              <button class="delete">Supprimer</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="add">
      <form action="" @submit.prevent="addUser()" @reset="reset()">
        <ul>
          <li><input v-model="newUser.nom" type="text" placeholder="Pseudo"></li>
          <li><input v-model="newUser.mdp" type="password" placeholder="Mot de passe"></li>
          <li><button type="submit">Ajouter</button></li>
          <li><button type="reset">Annuler</button></li>
        </ul>
      </form>
    </div>
  </div>
</template>

<script>
import {settings} from '../../assets/settings'

export default {
  name: 'Users',
  data () {
    return {
      users: [],
      newUser: {
        nom: '',
        mdp: ''
      }
    }
  },
  methods: {
    getUsers () {
      this.$http.get(settings.apiUrl + '/user/' + this.$parent.store.getToken()).then((response) => {
        this.users = response.body
      })
    },
    changeAdmin (userName) {
      let data = {
        estAdmin: true
      }
      this.$http.put(settings.apiUrl + '/user/' + userName + '/' + this.$parent.store.getToken(), {data: JSON.stringify(data)}).then((response) => {
        if (!response.body.success) {
          alert('error')
        }
      })
      this.getUsers()
    },
    addUser () {
      let error = ''
      if (this.newUser.nom.length < 3) {
        error += '\nEcrivez un nom de plus de 3 caractères'
      }
      if (this.newUser.mdp.length < 8) {
        error += '\nEcrivez un mot de passe de plus de 8 caractères'
      }
      if (error === '') {
        this.$http.post(settings.apiUrl + '/user/' + this.$parent.store.getToken(), {data: JSON.stringify(this.newUser)}).then((response) => {
          if (response.body.success) {
            alert('success')
          }
          this.getUsers()
        })
      } else {
        alert(error)
      }
    },
    reset () {
      this.newUser = {
        nom: '',
        mdp: ''
      }
    }
  },
  mounted () {
    if (this.$admin === 0) {
      window.location.replace('/#/groupes')
    }
    this.getUsers()
  }
}
</script>

<style scoped lang="scss">
  .display {
    width: calc(100% - 30px);
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    height: calc(100vh - 270px);
    padding: 15px;
    overflow-y: scroll;
    .header {
      display:block;
      width: 100%;
      ul {
        display: flex;
        list-style-type: none;
        border-bottom: 1px solid #aaaaaa;
        padding-bottom: 10px;
        li {
          a {
            text-decoration: none;
            color: #777777;
          }
        }
        .name {
          width: 20%;
        }
        .desc {
          width: 40%;
          cursor: text;
        }
        .date {
          width: 25%;
        }
        .public {
          width: 15%;
        }
      }
    }
    .liste {
      ul {
        list-style-type: none;
        li {
          .delete {
            padding: 10px;
            background-color: #C51010;
            border: none;
            border-radius: 4px;
            color: #fff;
            margin-left: 15%;
          }
          div {
            padding: 10px 0;
            p {
              display: inline-block;
            }
            .name {
              width: 20%;
            }
            .desc {
              width: 40%;
            }
            .date {
              width: 25%;
            }
            .public {
              width: 15%;
            }
          }
        }
      }
    }
  }
  .add {
    padding: 10px;
    background-color: #fff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    margin-top: 20px;
    ul {
      list-style-type: none;
      display: flex;
      justify-content: space-between;
      li {
        input, button {
          width: calc(100% - 20px);
          border: none;
          background-color: #e5e5e5;
          font-size: 20px;
          padding: 10px;
          border-radius: 4px;
          font-family: 'Roboto', sans-serif;
        }
        button {
          width: 100%;
          cursor: pointer;
        }
        button[type="submit"] {
          background-color: #175676;
          color: #fff;
        }
        button[type="reset"] {
          background-color: rgba(23, 86, 118, 0.2);
          color: #000;
        }
      }
      li:nth-child(1) {
        width: 30%;
      }
      li:nth-child(2) {
        width: 40%;
      }
      li:nth-child(3) {
        width: 17%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Page/users.vue